import { createDomainPagedAutoCompleteMetaData } from "commons/ultilities/dynamic-form/auto-complete/providers/schema-meta-data-helpers";
import { ObjectSchemaType } from "commons/ultilities/dynamic-form/hooks/use-form";
import { InputType } from "commons/ultilities/dynamic-form/models/control";
import { IUpdateMaterialGoodsReceipt } from "mobx-stores/_models/material-inventory/material-goods-receipt/material-goods-receipt";

import { date, number, string } from "yup";

export const getUpdateMaterialGoodsReceiptSchema =
  (): ObjectSchemaType<IUpdateMaterialGoodsReceipt> => ({
    id: {
      type: InputType.none,
    },
    receiptDate: {
      type: InputType.datePicker,
      gridSize: 12,
      label: "Ngày nhập",
      validattionYupSchema: date().required(),
    },
    items: {
      arraySchema: {
        id: {
          type: InputType.none,
          defaultValue: "",
        },
        materialId: {
          type: InputType.autoComplete,
          gridSize: 12,
          label: "Vật tư ",
          validattionYupSchema: string().required(),
          metaData: createDomainPagedAutoCompleteMetaData("material"),
        },
        unitOfCalculation: {
          type: InputType.text,
          gridSize: 6,
          label: "ĐVT",
          validattionYupSchema: string(),
        },
        amount: {
          type: InputType.number,
          gridSize: 6,
          label: "Số lượng",
          validattionYupSchema: number().required(),
        },
        wareHouse: {
          type: InputType.text,
          gridSize: 6,
          label: "Vị trí kho",
          validattionYupSchema: string().required().max(128),
        },
        brand: {
          type: InputType.text,
          gridSize: 6,
          label: "Hiệu",
          validattionYupSchema: string().required().max(128),
        },
        code: {
          type: InputType.text,
          gridSize: 6,
          label: "Mã hàng",
          validattionYupSchema: string().max(128),
        },
        origin: {
          type: InputType.text,
          gridSize: 6,
          label: "Xuất xứ",
          validattionYupSchema: string().max(256),
        },
        supplier: {
          type: InputType.text,
          gridSize: 6,
          label: "Nhà cung cấp",
          validattionYupSchema: string().max(128),
        },
        document: {
          type: InputType.text,
          gridSize: 6,
          label: "Chứng từ",
          validattionYupSchema: string().max(128),
        },
        note: {
          type: InputType.textArea,
          gridSize: 12,
          label: "Ghi chú",
          validattionYupSchema: string().max(512),
        },
      },
    },
  });
